import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { SubmitFormViewTopBar } from "./TopBar"

export const formSubmitterViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: SubmitFormViewTopBar,
}
